const RestrictedInput = require("components/forms/RestrictedInput");
const PropTypes = require("prop-types");
const assign = require("object-assign");

class Url extends RestrictedInput {

	static get propTypes() {
		return assign(super.propTypes, {
			prefix: PropTypes.string
		});
	}

	static get defaultProps() {
		return assign(super.defaultProps, {
			prefix: "https://"
		});
	}

	normalize(value) {
		return value.replace(/[^0-9a-z.-]/g, "");
	}

	get className() {
		let classList = ["url-field"];

		if (typeof this.props.className === "string") {
			classList.push(this.props.className);
		}

		return classList.join(" ");
	}

	get inputProps() {
		return assign(super.inputProps, {type: "text", className: this.className});
	}

	renderChildren() {
		return [
			<span key="prefix" className="url-prefix">{this.props.prefix}</span>,
		];
	}

}

module.exports = Url;


// WEBPACK FOOTER //
// ./resources/js/components/forms/Url.js